const BUSINESS_TYPES = [
  {
    label: "Comerciante Agrícola / Tienda Agropecuaria",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Refugio de Animales / Organización Benéfica",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Lote de Engorde",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Productor de Carne de Res",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Pollos de Engorde", value: "Broilers", id: "broilers" },
  {
    label: "Grupo de Compra",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Producción de Becerros",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Rancho/Desarrollador de Becerros",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Comprador de Ganado", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Productor por Contrato",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperativa", value: "Cooperative", id: "cooperative" },
  {
    label: "Oficina Corporativa",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Operación Vaca/Becerro",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Producción Lechera",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distribuidor / Agente",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Fábrica de Alimentos", value: "Feed Mill", id: "feed_mill" },
  { label: "Corral de Engorda", value: "Feedyard", id: "feedyard" },
  {
    label: "Productor/Engordador",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Incubadora", value: "Hatchery", id: "hatchery" },
  {
    label: "Producción de Vaquillas",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Integración de Ponedoras",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Ponedoras", value: "Layers", id: "layers" },
  { label: "Medios de Comunicación", value: "Media", id: "media" },
  {
    label: "Cooperativa/Comprador de Leche",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Productor Mixto/Otro",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Proveedor de Nutrientes",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Empacadora/Procesadora",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Tienda Minorista de Mascotas",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Farmacia", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Criador de Aves de Corral",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Integrador Avícola",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  {
    label: "Productor de Ovejas",
    value: "Sheep Producer",
    id: "sheep_producer",
  },
  {
    label: "Operación de Engorde",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Corral de Ganado/Rastro",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  {
    label: "Productor de Cerdos",
    value: "Swine Producer",
    id: "swine_producer",
  },
  { label: "Pavos", value: "Turkeys", id: "turkeys" },
  {
    label: "Universidad / Educación",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Clínica Veterinaria",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Mayorista / Minorista",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Comprador de Lana", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Requerido",
    },
  },
  salutation: {
    label: "Tratamiento",
    placeholder: "Seleccione Tratamiento",
    errors: {
      required: "El tratamiento es requerido",
      invalid: "Por favor seleccione un tratamiento válido",
    },
  },
  firstName: {
    label: "Nombre",
    placeholder: "Juan",
    errors: {
      authenticatedNameUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su nombre.",
      required: "El nombre es requerido",
      minLength: "El nombre debe tener al menos 2 caracteres",
      maxLength: "El nombre debe tener como máximo 50 caracteres",
    },
  },
  lastName: {
    label: "Apellido",
    placeholder: "García",
    errors: {
      authenticatedNameUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su nombre.",
      required: "El apellido es requerido",
      minLength: "El apellido debe tener al menos 2 caracteres",
      maxLength: "El apellido debe tener como máximo 50 caracteres",
    },
  },
  email: {
    label: "Correo electrónico",
    placeholder: "juan.garcia@ejemplo.com",
    description:
      "Por favor ingrese una dirección de correo electrónico personal, no una dirección compartida.",
    prefixWarningTitle: "Buzón compartido detectado",
    prefixWarningDescription:
      "Recomendamos usar una dirección de correo electrónico personal para una experiencia personalizada superior",
    errors: {
      authenticatedEmailUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su correo electrónico.",
      required: "El correo electrónico es requerido",
      invalidEmail: "Por favor ingrese un correo electrónico válido",
      emailAssociatedWithYourAccount:
        "Su dirección de correo electrónico está asociada con su cuenta y no puede ser cambiada.",
    },
  },
  confirmEmail: {
    label: "Confirmar correo electrónico",
    placeholder: "juan.garcia@ejemplo.com",
    errors: {
      authenticatedEmailUpdateTrial:
        "Ha iniciado sesión y no puede cambiar su correo electrónico.",
      required: "La confirmación del correo electrónico es requerida",
      invalidEmail: "Por favor ingrese un correo electrónico válido",
      emailMatchError: "Los correos electrónicos no coinciden",
    },
  },
  password: {
    label: "Contraseña",
    placeholder: "Ingrese su contraseña",
    errors: {
      required: "La contraseña es requerida",
    },
  },
  confirmPassword: {
    label: "Confirmar contraseña",
    placeholder: "Confirme su contraseña",
    errors: {
      required: "La confirmación de contraseña es requerida",
      passwordMatchError: "Las contraseñas no coinciden",
    },
  },
  addressLine1: {
    label: "Dirección Línea 1",
    placeholder: "Av. Reforma 123",
    errors: {
      required: "La Dirección Línea 1 es requerida",
      minLength: "La Dirección Línea 1 debe tener al menos 5 caracteres",
      maxLength: "La Dirección Línea 1 debe tener como máximo 100 caracteres",
    },
  },
  addressLine2: {
    label: "Dirección Línea 2",
    placeholder: "Depto 4B",
    errors: {
      required: "La Dirección Línea 2 es requerida",
      maxLength: "La Dirección Línea 2 debe tener como máximo 100 caracteres",
    },
  },
  city: {
    label: "Ciudad / Municipio",
    placeholder: "Ciudad de México",
    errors: {
      required: "La Ciudad / Municipio es requerida",
      minLength: "La Ciudad / Municipio debe tener al menos 2 caracteres",
      maxLength: "La Ciudad / Municipio debe tener como máximo 50 caracteres",
    },
  },
  country: {
    label: "País",
    placeholder: "Seleccionar país",
    errors: {
      required: "El país es obligatorio",
      invalid: "Seleccione un país válido",
    },
  },
  state: {
    label: "Estado",
    placeholder: "Seleccione Estado",
    errors: {
      required: "El estado es requerido",
      invalid: "Por favor seleccione un estado válido",
    },
  },
  jurisdiction: {
    label: "Jurisdicción de Licencia",
    placeholder: "Seleccione Jurisdicción de Licencia",
    errors: {
      required: "La Jurisdicción de Licencia es requerida",
      invalid: "Por favor seleccione una jurisdicción válida",
    },
  },
  zipCode: {
    label: "Código Postal",
    placeholder: "12345",
    errors: {
      required: "El Código Postal es requerido",
      invalid: "Por favor ingrese un Código Postal válido",
    },
  },
  role: {
    label: "Rol",
    placeholder: "Seleccione su rol",
    errors: {
      required: "Por favor seleccione su rol",
      invalid: "Por favor seleccione un rol válido",
    },
  },
  businessType: {
    label: "Tipo de Negocio",
    placeholder: "Seleccione Tipo de Negocio",
    errors: {
      required: "El tipo de negocio es requerido",
      invalid: "Por favor seleccione un tipo de negocio válido",
    },
  },
  businessName: {
    label: "Nombre del Negocio",
    placeholder: "Ingrese nombre del negocio",
    errors: {
      required: "El nombre del negocio es requerido",
      minLength: "El nombre del negocio debe tener al menos 2 caracteres",
      maxLength: "El nombre del negocio debe tener como máximo 100 caracteres",
    },
  },
  businessSearch: {
    label: "Búsqueda de Negocio:",
    addNewAccount: "Agregar Nueva Cuenta de Negocio",
    canNotFindBusiness: "¿No encuentra su negocio?",
    guideline:
      "Por favor ingrese su código postal y luego seleccione de la lista.",
    guidelineForNameSearch:
      "Por favor ingrese el nombre completo del negocio y luego seleccione de la lista.",
    placeholder: "¿Dónde trabaja?",
    noResults: "No se encontraron resultados",
    searching: "Buscando...",
    selectedBusinessHeading: "Negocio Seleccionado:",
    selectedBusinessNotCorrect: "¿No es correcto?",
    selectedBusinessTryAgain: "Intente de nuevo",
    selectedBusinessDismiss: "Descartar negocio",
    resultsFound: {
      singular: "1 negocio encontrado",
      plural: "Múltiples negocios encontrados",
    },
    errors: {
      network:
        "Estamos teniendo problemas para conectar con el Buscador de Negocios. Por favor intente más tarde.",
    },
  },
  explicitConsent: {
    label:
      "Al marcar esta casilla acepto los Términos de Uso de Elanco, reconozco que Elanco recopilará y procesará mi información personal de acuerdo con el Aviso de Privacidad de Elanco",
    errors: {
      required: "El consentimiento de correo electrónico es requerido",
    },
  },
  explicitSmsConsent: {
    label:
      "Al marcar esta casilla, acepto recibir comunicaciones de marketing de Elanco por SMS/mensaje de texto.",
    errors: {
      required: "El consentimiento para SMS es obligatorio",
    },
  },
  telephone: {
    label: "Teléfono Personal",
    placeholder: "Ingrese su teléfono personal",
    dialCodeLabel: "Código",
    dialCodePlaceholder: "Buscar país…",
    errors: {
      invalid: "Por favor ingrese un número de teléfono válido.",
    },
  },
  businessTelephone: {
    label: "Teléfono del Negocio",
    placeholder: "Ingrese su teléfono del negocio",
    dialCodeLabel: "Código",
    dialCodePlaceholder: "Buscar país…",
    errors: {
      invalid: "Por favor ingrese un número de teléfono válido.",
    },
  },
  professionalNumber: {
    label: "Número Profesional",
    placeholder: "1234567",
    errors: {
      required: "Por favor ingrese un número profesional",
      maxLength: "La entrada excede el límite de caracteres",
    },
  },
  addressSearch: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  businessSearchField: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  checkbox: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  combobox: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  datePicker: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  dateRange: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  dateTime: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  emailField: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  fileInput: {
    errors: {
      required: "Por favor seleccione un archivo",
    },
  },
  number: {
    errors: {
      required: "Por favor ingrese un número",
      minValue: "Por favor ingrese un valor mayor que el mínimo",
      maxValue: "Por favor ingrese un valor menor que el máximo",
    },
  },
  passwordField: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  rangeSlider: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  select: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  telephoneField: {
    errors: {
      required: "Por favor ingrese solo números",
      invalidTelephone: "Por favor ingrese un número de teléfono válido",
      invalidFormat: "Formato de número inválido",
    },
  },
  text: {
    errors: {
      required:
        "Por favor use solo letras (A-Z), números (0-9), y sin símbolos",
      maxLength: "La entrada excede el límite de caracteres",
      minLength: "La entrada debe tener al menos 2 caracteres",
    },
  },
  textarea: {
    characters: "caracteres",
  },
  time: {
    errors: {
      required: "Este campo es requerido",
    },
  },
  form: {
    errors: {
      generic:
        "Encontramos un error al enviar su formulario. Por favor intente de nuevo.",
      reportAnIssue: "Por favor reporte un problema.",
      configuration: "Error de Configuración",
      noFormQuestionsAvailable: "No hay preguntas de formulario disponibles.",
      formComponentLoad:
        "El componente del formulario no pudo ser cargado debido a un campo no soportado.",
      code: "Código",
      type: "Tipo",
      missingRequiredFields:
        "Este formulario falta campos requeridos (Correo electrónico y/o Consentimiento). Por favor contacte a un administrador para corregir la configuración del formulario.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Académico", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Bienestar Animal - Otro",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Bienestar Animal - Personal de Tienda",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Bienestar Animal - Veterinario",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Bienestar Animal - Enfermero Veterinario",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Bienestar Animal - Voluntario",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Extensión Ganado de Res / Engorda",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Productor de Carne de Res",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Criador", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Administrador de Negocios / Recepcionista",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Dueño de Negocio / Socio",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Nutricionista Consultor",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Empleado Veterinario Corporativo (no-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Productor Lechero",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distribuidor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Representante de Distribuidor, Campo",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Representante de Distribuidor, Interno",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Institución Educativa - Estudiante Preparatoria",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Institución Educativa - Estudiante TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Institución Educativa - Estudiante Universitario",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Estilista de Mascotas", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Director Médico/Clínico",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Ventas de Nutrición / Alimentos",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Profesional en Nutrición",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutricionista", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Gerente de Oficina/Clínica",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "Minorista OTC", id: "otc_retailer" },
  { value: "Pharmacist", label: "Farmacéutico", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Farmacia - Personal",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Productor Porcino", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Productor Avícola",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Dueño de Clínica, No MVZ",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Recepcionista/Servicio al Cliente",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Tienda Revendedora - Personal",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Productor - Mixto/Otro",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Minorista",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Productor de ovejas",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Estudiante RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Tierarzt/Tierärztin",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Entrenador", id: "trainer" },
  { value: "Veterinarian", label: "Veterinario", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinario, Dueño de Clínica",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Asistente Veterinario",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Enfermero Veterinario",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Clínica Veterinaria - Otro",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Clínica Veterinaria - Veterinario",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Clínica Veterinaria - Enfermero Veterinario",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Especialista Veterinario",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Estudiante de Veterinaria",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Cirujano Veterinario",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Técnico Veterinario",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Mayorista", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Srta.",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Sr.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Sra.",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Sra.",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
